<template>
    <v-container fluid fill-height>
        <Header title="Pagina niet gevonden"></Header>
        <v-layout align-center justify-center>
            <div>
                <v-alert>De pagina kon niet worden gevonden.</v-alert>
                <v-btn @click="back" block color="primary" class="elevation-0">Terug naar hoofdpagina</v-btn>
            </div>
        </v-layout>
    </v-container>
</template>

<script>
import Header from "../components/layout/Header";
import {mapState} from "vuex";

export default {
    name: 'NotFound',
    components: {
        Header,
    },
    computed: {
        ...mapState({
            isLoggedIn: state => state.auth.isLoggedIn,
        }),
    },
    methods: {
        back () {
            if (this.isLoggedIn ) {
                this.$router.push({name: 'Home'});
            } else {
                this.$router.push({name: 'Login'});
            }
        },
    },
}
</script>
